module.exports = __webpack_public_path__ + "img/spring_trip-20160416-18.0413dea5.jpg";